export default __webpack_public_path__ + "static/media/get-inspired-white.7fa7b10c.svg";